import React from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
import s from './TrustBadges.css';

// Grid of icon + label + short text. `items` = [{ icon (svg path d), title, text }].
function TrustBadges({ heading, items = [] }) {
  return (
    <div className={s.block}>
      {heading ? <h2 className={s.heading}>{heading}</h2> : null}
      <div className={s.grid}>
        {items.map((it) => (
          <div className={s.card} key={it.title}>
            <div className={s.ic}>
              <svg viewBox="0 0 24 24" aria-hidden="true">
                <path d={it.icon} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </div>
            <h3 className={s.title}>{it.title}</h3>
            <p className={s.text}>{it.text}</p>
          </div>
        ))}
      </div>
    </div>
  );
}

export default withStyles(s)(TrustBadges);
